import React, { useCallback, useEffect, useState } from 'react';

import PageTitle from '../../components/stateless/PageTitle';
import Heading from '../../components/stateless/Heading';

import { ServicesList, SolutionsList } from '../../constants';

import './index.scss';
import { Link } from 'react-router-dom';
import IconCard from "../../components/stateless/IconCard";

function Services() {
  const [currentService, setCurrentService] = useState(ServicesList[0]);
  const markup = (str) => ({ __html: str });

  const solutionId = window.location.hash.split('#')[1];
  const [solutionSlug, setSolutionSlug] = useState(solutionId || '');
  const [sections, setSections] = useState([]);

  useEffect(() => {
    setSections(document.querySelectorAll('section.section-anchor'));
  }, []);

  const handleScroll = useCallback(() => {
    const scrollY = window.pageYOffset;
    const inBottomPage = (window.innerHeight + window.scrollY) >= document.body.offsetHeight

    sections.forEach(current => {
      const { offsetHeight, offsetTop, id } = current;
      const sectionTop = offsetTop - 100;
      if (scrollY > sectionTop && scrollY <= sectionTop + offsetHeight) {
        setSolutionSlug(id);
      }
      if (inBottomPage) {
          setSolutionSlug(sections[sections.length-1].id)
      }
      if (scrollY === 0) {
        setSolutionSlug(ServicesList[0].slug);
      }
    });
  }, [sections]);

    window.addEventListener('scroll', handleScroll);

  return (
    <>
      <PageTitle heading="Services" description="Get access to BetConstruct’s highly-appraised Risk Management, Customer Support services"/>
      <div className="solutions-content-wrapper">
        <div className="container-layout">
          <div className="solutions-container">
            <nav className="solutions-content-menu">
              {
                ServicesList.map(item =>
                  <a href={`#${item.slug}`} className="solutions-content-menu-inner" key={item.slug} onClick={() => setSolutionSlug(item.slug)}>
                    <label htmlFor={item.slug + 'contentMenuITem'} className={item.slug === solutionSlug ? 'text-selected' : ''}>{item.name}</label>
                  </a>
                )
              }
            </nav>
            <div className="content-item">
              {
                ServicesList.map(service => {
                  return (
                 /*   <section id={service.slug} key={service.slug} className="section-anchor">
                      <Heading size="small" content={service.name}/>
                      <div dangerouslySetInnerHTML={markup(service.description)}></div>
                      {
                        service.pricing
                          ? <>
                            <Heading size="small" content="Pricing"/>
                            <div dangerouslySetInnerHTML={markup(service.pricing)}></div>
                          </>
                          : ''
                      }
                    </section>*/

                  <section id={service.slug} key={service.slug} className="section-anchor">
                    <p className="solutions-menu-title">{service.name}</p>
                    <p className="solutions-menu-t-txt">{service.description}</p>
                    {
                      service.nestedSubMenu?.products &&
                      <>
                        <div className="solutions-menu-inner">
                          {
                            service.nestedSubMenu?.products.map(nestedSubItem =>
                              <Link to={nestedSubItem.path} className="solutions-menu-i-row" key={nestedSubItem.name}>
                                <div className="solutions-menu-i-top">
                                {nestedSubItem.icon && <IconCard size="small" icon={nestedSubItem.icon}/>}
                                  <div className="text-capitalize">{nestedSubItem.name}</div>
                                </div>
                                <p className="solutions-menu-i-txt">{nestedSubItem.shortDescription}</p>
                              </Link>
                            )
                          }
                        </div>
                      </>
                    }
                  </section>
                );
                })}
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Services;
